class SecurityError extends Error {
  constructor(message) {
    super(message); // Call the parent constructor with the message
    this.name = this.constructor.name; // Set the error name to the class name
  }
}

export default SecurityError;